module.exports = __webpack_public_path__ + "img/followers.1ec472d8.svg";